import React, { FC } from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";

interface ImageDraftProps {
    draftImage: any;
    onRemoveImageDraft: () => void;
}

const ImageDraft: FC<ImageDraftProps> = ({
    draftImage,
    onRemoveImageDraft,
}) => {
    return (
        draftImage && (
            <div style={{ position: "relative" }} key={draftImage.id}>
                <Button
                    onClick={onRemoveImageDraft}
                    sx={{
                        position: "absolute",
                        right: 0,
                        zIndex: 1,
                        p: "4px",
                        minWidth: "unset",
                        color: "grey.500",
                    }}
                >
                    <DeleteIcon />
                </Button>
                <img
                    src={draftImage.src}
                    alt="preview"
                    style={{ width: "100%", zIndex: 0 }}
                />
            </div>
        )
    );
};

export default ImageDraft;
